import React, { Component } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  text:{
    fontSize: 30,
    textAlign: 'center',
    color:'#444444',
  },
})

class Result extends Component{
  render(){
    const { classes } = this.props;
    return (
      <ReactCSSTransitionGroup
        className="container result"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >
        <div>
          <h3 className={classes.text}>受検期限が切れています。</h3>
        <h3 className={classes.text}>再受検をご希望の方は担当者へ連絡をお願いいたします。</h3>
          <h3 className={classes.text}>Mail：recruit@avinton.com</h3>
        </div>
      </ReactCSSTransitionGroup>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Result);



// WEBPACK FOOTER //
// ./src/components/Login/TimeOver.js